export enum ItemOrQuantityIssueTypeInternational {
    SHIPMENT_OVERAGE = 'Shipment Overage',
    SHIPMENT_SHORTAGE_APPARENT = 'Shipment Shortage (Apparent)',
    SHIPMENT_SHORTAGE_CONCEALED = 'Shipment Shortage (Concealed)',
    SPLIT_SHIPMENT = 'Split Shipment',
    MISSING_ITEM = 'Missing Item',
    JAPAN_NOT_LOT_RECEIVED = 'Japan Not Lot Received',
    WRONG_BATCH_SHIPPED = 'Wrong Batch Shipped',
    WRONG_SERIAL_SHIPPED = 'Wrong Serial Shipped',
    WRONG_SMN_SHIPPED = 'Wrong SMN Shipped',
    RECEIVED_UNORDERED_ITEM = 'Received Unordered Item'
}
